export interface Action {
    id: string | null,
    title: string;
    description: string;
    requirement: string | null,
    frequency: string | null,
    piResource: string | null,
    resourceUrl: string | null,
    source: string | null,
    sdg: number | null
}

export interface RecommendedAction {
    eventId: string | null,
    id: string | null,
    title: string;
    description: string;
    source: string | null,
    sourceId: string | null,
    sdg: number | null,
    rejected: boolean    
}

export function convertActionToRecommended(
    action: Action,
    eventId: string | null = null,
    rejected: boolean = true
  ): RecommendedAction {
    return {
      eventId,
      id: action.id,                     // carry over the action ID
      title: action.title,
      description: action.description,
      source: action.source ?? null,     // keep original source
      sourceId: action.id,               // or whatever mapping you intend
      sdg: action.sdg ?? null,
      rejected: rejected                    // default for new recommended actions
    };
  }
  